













import { Component, Mixins, } from "vue-property-decorator";
import { InOrderLayout } from "../../layouts";
import { DocumentArchiveIndicatorMixin } from "./mixins";

@Component({
  components: {
    InOrderLayout,
  }
})
export default class DocumentArchiveIndicator extends Mixins(DocumentArchiveIndicatorMixin) {
}
